import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  IconButton
} from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';

const useStyles = makeStyles(() => ({
  root: {}
}));

const AlertDetails = props => {
  const { className, alert, setEditMode, ...rest } = props;

  const classes = useStyles();

  const [values, setValues] = useState({ ...alert });

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const states = [
    {
      value: 'active',
      label: 'Active'
    },
    {
      value: 'disabled',
      label: 'Disabled'
    }
  ];

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <form
        autoComplete="off"
        noValidate
      >
        <CardHeader
          title="Alert"
          action={
            <IconButton onClick={() => setEditMode(true)}>
              <Edit />
            </IconButton>
          }
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Alert Name"
                label="Alert Name"
                margin="dense"
                name="name"
                onChange={handleChange}
                required
                value={values.name}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Period"
                margin="dense"
                name="period"
                onChange={handleChange}
                required
                value={values.period}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Comparator"
                margin="dense"
                name="comparator"
                onChange={handleChange}
                required
                value={values.comparator}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Threshold"
                margin="dense"
                name="threshold"
                onChange={handleChange}
                type="number"
                value={values.threshold}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Status"
                margin="dense"
                name="status"
                onChange={handleChange}
                required
                select
                // eslint-disable-next-line react/jsx-sort-props
                SelectProps={{ native: true }}
                value={values.status}
                variant="outlined"
                disabled
              >
                {states.map(option => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Count"
                margin="dense"
                name="count"
                onChange={handleChange}
                required
                value={values.count}
                variant="outlined"
                disabled
              />
            </Grid>
          </Grid>
        </CardContent>
      </form>
    </Card>
  );
};

AlertDetails.propTypes = {
  className: PropTypes.string
};

export default AlertDetails;
